import type { StatusOption } from "../components/base/status-dropdown";

/**
 * BICS endpoint lifecycle codes and how they are shown. Shared by the SIM Cards
 * table's status dropdown and the universal search SIM result (OTO-155), so a
 * card reads the same in both.
 */
export const SIM_CARD_STATUS_OPTIONS: StatusOption[] = [
  { value: "H", label: "Hold", variant: "outline" },
  { value: "PA", label: "Pre-active", variant: "outline" },
  { value: "AT", label: "Active Test", variant: "outline" },
  { value: "AI", label: "Active Inventory", variant: "outline" },
  { value: "A", label: "Active", variant: "default" },
  { value: "S", label: "Suspended", variant: "destructive" },
];

/** The display option for a BICS status code; unknown codes show as-is. */
export function simCardStatusOption(status: string): StatusOption {
  return (
    SIM_CARD_STATUS_OPTIONS.find((option) => option.value === status) ?? {
      value: status,
      label: status,
      variant: "outline",
    }
  );
}
